import { makePath, PATH } from 'shared';
import { BASE_PATH_EDS } from './constants';
export const getIntroSlug = () => {
    const slug = BASE_PATH_EDS + PATH.EDS.INDEX;
    const url = makePath(slug);
    return url;
};
export const getOfferSlug = () => {
    const slug = BASE_PATH_EDS + PATH.EDS.WATERFALL;
    const url = makePath(slug);
    return url;
};
